export default "__VITE_ASSET__CUQvXq8I__"